import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container, Hidden } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import TextField from '@material-ui/core/TextField';
import {authConfig} from '../auth/config';
import Cardconsulta from './cardConsulta';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import {Link} from 'react-router-dom';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';//em transito
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import EventBusyIcon from '@material-ui/icons/EventBusy';//inderefiras
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import EventIcon from '@material-ui/icons/Event';//concluidas
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Unidadetransporte from '../componentes/unidadetransporterelatorio';
import Centroadministrativo from "../componentes/centroadministrativorelatorio";
import Unidadedepartamento from '../componentes/unidadedepartamentorelatorio';
import { Impressaorelatoriodeferidas } from '../util/Impressaorelatoriodeferidas';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   menuButton: {
    //marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    
  },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''



export const  Consultas = withRouter(({history}) => {
   
  
  //**************************************************** */

  const visualizarImpressao = () => {
    
  //var rel = Impressaosolicitacao(props)
    //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
    //rel.criarpdf();
   console.log(lista);
   var qtd = lista.length;
   //console.log(statelista);
      const classeImpressaov = new Impressaorelatoriodeferidas(lista,dataini,datafim,qtd);
      const documentov = classeImpressaov.GerarDocumento();
      pdfMake.createPdf(documentov).open({}, window.open('', '_blank'));
    
    
  }
  //firebase.firestore.Timestamp.fromDate(new Date(datahorasaida))
  const [statelista, setalista]=React.useState([]);
  var lista=[];
  const handlegerarelatorio= ()=>{
    if((dataini!='')&&(datafim!='')){
      if(state.checkedunidade){
          if (unidade!='') {
            var db = firebase.firestore();
            //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
            var query = db.collection("agenda").where("status",'==',"deferido").where("datahorasaida",">=", firebase.firestore.Timestamp.fromDate(new Date(dataini))).where("datahorasaida","<=", firebase.firestore.Timestamp.fromDate(new Date(datafim)))
            .where('filaunidadetransporte','==',unidade.id).get()
            .then(function(querySnapshot) {
            
             querySnapshot.forEach(function(doc) {
             
              lista.push({id: doc.id, datahoraretorno: new Date(doc.data().datahoraretorno.seconds*1000).toLocaleString("pt-BR"),
               observacao:doc.data().observacao,anexo:doc.data().anexo,
                datahorasaida:new Date(doc.data().datahorasaida.seconds*1000).toLocaleString("pt-BR"), dsolicitacao: doc.data().dsolicitacao, campisolicitante:doc.data().campisolicitante,valorkmrodado:doc.data().valorkmrodado,
                listapassageiros: doc.data().listapassageiros, depsolicitacao: doc.data().depsolicitacao[0].nomedepsol, nomesolicitante: doc.data().nomesolicitante, idsolicitante:doc.data().idsolicitante,
                npassageiro: doc.data().npassageiro, nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo, totalkm: doc.data().kilometragem,valorkm:doc.data().valorkm,
                siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadasida: doc.data().listaparadasida,listaparadasvolta: doc.data().listaparadasvolta,
                localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipodeslocamento:doc.data().tipodeslocamento, nomerespdespesas:doc.data().nomerespdespesas,
                fonerespdespesas:doc.data().fonerespdespesas, respdespesas:doc.data().respdespesas, autorizacoes:doc.data().autorizacoes,veiculo: doc.data().veiculo, motorista: doc.data().motorista,kminicio: doc.data().kminicio,
                kmfinal:doc.data().kmfinal,
              });


            console.log("agenda lista ps ", lista);
            
            setalista (currentArray => [...currentArray, doc.data()]);
    
          });
          visualizarImpressao();
         
        })
         .catch(error => {
             console.log('Não encontramos solicitações cadastrados', error);
         });
        
          } else {
            alert("Selecione uma Unidade de Transporte")
          }
        }else{
          //só por data
          var db = firebase.firestore();
            //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
            var query = db.collection("agenda").where("status",'==',"deferido").where("datahorasaida",">=", firebase.firestore.Timestamp.fromDate(new Date(dataini))).where("datahorasaida","<=", firebase.firestore.Timestamp.fromDate(new Date(datafim)))
            .get()
            .then(function(querySnapshot) {
            
             querySnapshot.forEach(function(doc) {
             
              lista.push({id: doc.id, datahoraretorno: new Date(doc.data().datahoraretorno.seconds*1000).toLocaleString("pt-BR"),
               observacao:doc.data().observacao,anexo:doc.data().anexo,
                datahorasaida:new Date(doc.data().datahorasaida.seconds*1000).toLocaleString("pt-BR"), dsolicitacao: doc.data().dsolicitacao, campisolicitante:doc.data().campisolicitante,valorkmrodado:doc.data().valorkmrodado,
                listapassageiros: doc.data().listapassageiros, depsolicitacao: doc.data().depsolicitacao[0].nomedepsol, nomesolicitante: doc.data().nomesolicitante, idsolicitante:doc.data().idsolicitante,
                npassageiro: doc.data().npassageiro, nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo, totalkm: doc.data().kilometragem,valorkm:doc.data().valorkm,
                siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadasida: doc.data().listaparadasida,listaparadasvolta: doc.data().listaparadasvolta,
                localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipodeslocamento:doc.data().tipodeslocamento, nomerespdespesas:doc.data().nomerespdespesas,
                fonerespdespesas:doc.data().fonerespdespesas, respdespesas:doc.data().respdespesas, autorizacoes:doc.data().autorizacoes,veiculo: doc.data().veiculo, motorista: doc.data().motorista,kminicio: doc.data().kminicio,
                kmfinal:doc.data().kmfinal,
              });


            console.log("agenda lista ps ", lista);
            
            setalista (currentArray => [...currentArray, doc.data()]);
    
          });
          visualizarImpressao();
         
        })
         .catch(error => {
             console.log('Não encontramos solicitações cadastrados', error);
         });

        }
      
    
  }else{
    alert("Selecione as datas de inicio e fim do relatório")
  }
  }
  //*****************************************************controle botões solicitações */
  const [unidade, setaunidade] = React.useState({id:''});
  const [nucleo, setanucleo] = React.useState('');
  const [departamento, setadepartamento] = React.useState('');

  //************************** */
  const [state, setState] = React.useState({
    
    checkeddepartamento: false, checkednucleo: false, checkedunidade: false,
  });
  


const handleCheck = (event) => {
  setState({ ...state, [event.target.name]: event.target.checked });
  
};

const [dataini, setadataini] = React.useState('');

  const [datafim, setadatafim] = React.useState('');

   //*****************************************************controle botões solicitações */
  //*****************************************************controle botões solicitações */
  function handlerelmotoristas(){
    history.push('/Relatoriomotoristas');  

}
function handlerelfaturamento(){
  history.push('/Relatoriofaturamento');  

}
 
function handlerelviagens(){
  history.push('/Relatorios');  
}

function handlereldeferidas(){
  history.push('/Relatoriodeferidas');  
}

function handlerelanalise(){
  history.push('/Relatorioanalise');  
}

function handlerrelveiculos(){
  history.push('/Relatorioveiculos');  
}
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      <br></br>
      <Container align='center'>
          <Grid container align="center">
          
          <Grid item xs>
            <Button        
                      variant="contained"
                      color="secondary"
                      startIcon={<EventNoteIcon />}
                      className={classes.submit}
                      onClick={handlerelviagens}
                      
                    >
                     Rel. de Viagens
                    </Button>
                  
            </Grid>
          
          <Grid item>
            <Button
        variant="contained"
        color="secondary"
        startIcon={<EventAvailableIcon />}
        onClick={handlerelanalise}
        className={classes.menuButton}
      >
       Rel. Análise
      </Button>
            
  </Grid>

  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<DepartureBoardIcon />}
            className={classes.submit}
            onClick={handlereldeferidas}
            
          >
             Rel. Deferidas
          </Button>
         
  </Grid>
  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<DirectionsCarIcon />}
            className={classes.submit}
            onClick={handlerrelveiculos}
            
          >
            Rel. Veículos
          </Button>
  </Grid>
  
  

 
  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<AssignmentIndIcon />}
            className={classes.submit}
            onClick={handlerelmotoristas}
            
          >
            Rel. Motoristas
          </Button>
  </Grid>

  <Grid item xs>
  <Button        
            variant="contained"
            color="secondary"
            startIcon={<AssignmentIndIcon />}
            className={classes.submit}
            onClick={handlerelfaturamento}
            
          >
            Rel. Faturamento
          </Button>
  </Grid>


          </Grid>
          </Container>
      <br></br>
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Relatório de Solicitações Deferidas
          </Typography>
          <Container maxWidth="xs">
         
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">
         <br></br>
      <br></br>
         <TextField
      fullWidth
      required
      onChange={ e=>setadataini(e.target.value)}
      variant="outlined"
        id="datetimeini"
        label="Data Inicial do relatório"
        type="date"
        value={dataini}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />
      <br></br>
      <br></br>

<TextField
      fullWidth
      required
     onChange={ e=>setadatafim(e.target.value)}
      variant="outlined"
        id="datetimefim"
        label="Data Final do relatório"
        type="date"
        value={datafim}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />



      <FormGroup>
<FormControlLabel
        control={
          <Checkbox
          required
            checked={state.checkedunidade}
            onChange={handleCheck}
            name="checkedunidade"
            color="primary"
          />
        }
       
        label ="Filtrar por Unidade de Transporte "
        
        
      />

</FormGroup>
<div id="uni" hidden={!state.checkedunidade} >
<Unidadetransporte unidade={unidade} setaunidade={setaunidade}/>
</div>

<Button onClick={handlegerarelatorio} color="primary">
            Gerar
          </Button>
           </div>
          
          
      </div>
      </Container>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Consultas;
